var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M3.41 3.744a.5.5 0 0 1 0-.707l.235-.236a.5.5 0 0 1 .708 0l10.606 10.606a.5.5 0 0 1 0 .707l-.236.236a.5.5 0 0 1-.707 0L3.41 3.744Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M13.611 2.768a.5.5 0 0 1 .707 0l.236.236a.5.5 0 0 1 0 .707L3.947 14.318a.5.5 0 0 1-.707 0l-.235-.236a.5.5 0 0 1 0-.707L13.61 2.768Z",
    clipRule: "evenodd"
  })));
};
export default SvgCloseIcon;